import { useState, useEffect } from 'react';

interface WelcomePopupState {
  isVisible: boolean;
  isNewUser: boolean;
  hasShownToday: boolean;
}

export const useWelcomePopup = () => {
  const [popupState, setPopupState] = useState<WelcomePopupState>({
    isVisible: false,
    isNewUser: false,
    hasShownToday: false,
  });

  useEffect(() => {
    // إظهار البوب أب في كل مرة يتم تحميل الصفحة
    const showWelcomePopup = () => {
      // دائماً نعتبر المستخدم جديد لإظهار نافذة الترحيب
      const isNewUser = true;

      setPopupState({
        isVisible: true,
        isNewUser,
        hasShownToday: false,
      });
    };

    // تأخير بسيط لإظهار البوب أب بعد تحميل الصفحة
    const timer = setTimeout(showWelcomePopup, 1000);
    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setPopupState((prev) => ({
      ...prev,
      isVisible: false,
      hasShownToday: true,
    }));
  };

  const showPopup = (isNewUser: boolean = false) => {
    setPopupState({
      isVisible: true,
      isNewUser,
      hasShownToday: false,
    });
  };

  return {
    isVisible: popupState.isVisible,
    isNewUser: popupState.isNewUser,
    hasShownToday: popupState.hasShownToday,
    closePopup,
    showPopup,
  };
};
